import React from 'react';

const CustomerInfoField = ({ label, value }) => (
  <div className="d-flex align-items-center mb-1">
    <h6 className="m-0">{label}</h6>
    <p className="m-0 ml-3">{value}</p>
  </div>
);

export default CustomerInfoField;
